import { render, staticRenderFns } from "./WorkIt.vue?vue&type=template&id=5df1bc6e&"
import script from "./WorkIt.vue?vue&type=script&lang=js&"
export * from "./WorkIt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports